export default {
  date: 'April 11, 2024',
  title: 'What changes can be made to the Getfloorplan layouts?',
  description: 'Getfloorplan team can manually change your floor plan after it has been processed:',
  id: 'what-changes-can-be-made-to-the-Getfloorplan-layouts',
  jsx: () => (
    <div class='novelty__text'>
      <p>Getfloorplan team can manually change your floor plan after it has been processed:</p>
      <p>
        We can make the following modifications:
        <br></br>
        1. Add, move, or remove furniture.
        <br></br>
        2. Add or remove walls.
        <br></br>
        3. Add, move, or remove windows and doors.
        <br></br>
        4. Resize rooms.
        <br></br>
      </p>
      <p>
        If you have specific requests beyond the ones above, we can also collaborate on an individual style that suits your needs.
        <br></br>
        This includes customizing color schemes, textures, and textile elements.
      </p>
      <p>Moreover, we can develop an entirely new style featuring different furniture, interior elements, textures, and textiles.</p>
      <p>
        For more detailed information about the services or to discuss your specific requirements, please, feel free to contact us via email
        <a href='mailto:support@getfloorplan.com'> support@getfloorplan.com</a>. We’re here to make sure your floor plan looks exactly as you wish!
      </p>
    </div>
  ),
  thumb: 'news/12.webp',
};
